import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          {/* <p className="text-sm text-designColor tracking-[4px]">Jun 2021 - Jan 2023</p> */}
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="relative mt-14 w-full flex flex-col gap-10">
        <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-black bg-opacity-30"></div>
        {/* <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10"> */}
          <ResumeCard
            title="Software Engineer"
            subTitle="(Jun 2021 - Jan 2023)"
            result={<span style={{ color: '#38b2ac' }}>HYDERABAD, INDIA</span>}
            des="I held a position as a Software Engineer within the CIT-Labeling team of Core Transportation Technology. My role involved developing and designing Amazon labels commonly seen on packages, analyzing route data for packages, optimizing code, and identifying and resolving bugs in internal tools. We manage around 200+ carriers and 10000+ ship methods. I also contributed to a significant project at Amazon called the SSL (Small Shipping Label) project, valued at over $50 million. This initiative aimed to reduce the global carbon footprint by minimizing the size of Amazon labels. I successfully oversaw the implementation of the SSL project across India, the United States, and Japan. I resolved numerous issues in the 'Passport' tool, enhancing user experience and operational efficiency for stakeholders. My technological expertise includes Java, Python, SQL, Docker, API's, MERN stack, AWS, XML, CI/CD pipelines."
          />
          <ResumeCard
            title="Software Engineer Intern"
            subTitle="(Apr 2019 - May 2019)"
            result={<span style={{ color: '#38b2ac' }}>HYDERABAD, INDIA</span>}
            des="• Designed and built over 20 responsive web pages for Kennisworld.com using HTML5, CSS3, and JavaScript, ensuring a seamless user experience and cross-browser compatibility. 
            Collaborated with a development team to integrate 5 key modules, including user authentication, content management, and interactive learning tools, enhancing platform functionality and user engagement by 30%."
          />
          {/* <ResumeCard
            title="Front-end Developer"
            subTitle="Nike - (2020 - 2011)"
            result="Oman"
            des="The Oman economy has grown strongly over recent years, having transformed itself from a producer and innovation-based economy."
          /> */}
        </div>
      </div>
      {/* <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2001 - 2020</p>
          <h2 className="text-4xl font-bold">Trainer Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Gym Instructor"
            subTitle="Rainbow Gym Center (2015 - 2020)"
            result="DHAKA"
            des="The training provided by universities in order to prepare people to work in various sectors of the economy or areas of culture."
          />
          <ResumeCard
            title="Web Developer and Instructor"
            subTitle="SuperKing College (2010 - 2014)"
            result="CANADA"
            des="Higher education is tertiary education leading to award of an academic degree. Higher education, also called post-secondary education."
          />
          <ResumeCard
            title="School Teacher"
            subTitle="Kingstar Secondary School (2001 - 2010)"
            result="NEVADA"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          />
        </div>
      </div> */}
    </motion.div>
  );
};

export default Experience;
